var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChuyenDoiUidSdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000031178962041046322320000002806827735737554571_);}\n\t.st2{fill:url(#SVGID_00000118377679528690443600000007830999742041038749_);}\n\t.st3{fill:url(#SVGID_00000163035495611410495620000009311882121361059738_);}\n\t.st4{fill:url(#SVGID_00000069365884623056282590000016617579739461663396_);}\n\t.st5{fill:url(#SVGID_00000145773323311592724650000006377767036971616156_);}\n\t.st6{fill:url(#SVGID_00000129884629004461895320000009375219680758560393_);}\n\t.st7{fill:url(#SVGID_00000074400021034436246600000010140007165466500783_);}\n\t.st8{fill:url(#SVGID_00000120557077336600743310000007320133208811239078_);}\n\t.st9{fill:url(#SVGID_00000165954404669809942950000003446444927364537237_);}\n\t.st10{fill:url(#SVGID_00000173866398266702910370000017789469160693433771_);}\n\t.st11{fill:url(#SVGID_00000073718252355400913130000008711858891035122611_);}\n\t.st12{fill:url(#SVGID_00000016789416724113566810000003604492316115399838_);}\n\t.st13{fill:url(#SVGID_00000081623965002108763620000017726230171130842503_);}\n\t.st14{fill:url(#SVGID_00000080900117767525961970000007273455374489123495_);}\n\t.st15{fill:url(#SVGID_00000116935230259715935850000012908150871451659701_);}\n\t.st16{fill:url(#SVGID_00000166672937942505612060000003196230694600034200_);}\n\t.st17{fill:url(#SVGID_00000180368777848804359100000015156602047066566785_);}\n\t.st18{fill:url(#SVGID_00000183954027359500919830000011211627793659593856_);}\n\t.st19{fill:url(#SVGID_00000058578167689613812100000008346896065169323435_);}\n\t.st20{fill:url(#SVGID_00000063607665064530556690000008132613145599400857_);}\n\t.st21{fill:url(#SVGID_00000091695256994738965650000010923975868056804747_);}\n\t.st22{fill:url(#SVGID_00000181786748770663366220000004951603887527355567_);}\n\t.st23{fill:url(#SVGID_00000070838764516991291540000008633763081384106893_);}\n\t.st24{fill:url(#SVGID_00000030454526534174164510000014311677458355777945_);}\n\t.st25{fill:url(#SVGID_00000039829124519980072310000014486202676513040009_);}\n\t.st26{fill:url(#SVGID_00000152945534271082680810000002588174983943402406_);}\n\t.st27{fill:url(#SVGID_00000059286040272037225840000012124495380607116710_);}\n\t.st28{fill:url(#SVGID_00000021114779411752211870000011070181357257827998_);}\n\t.st29{fill:url(#SVGID_00000048476445850433567550000014910028629094552499_);}\n\t.st30{fill:url(#SVGID_00000078044476731614037780000011991555467882191023_);}\n\t.st31{fill:url(#SVGID_00000151528007427191958190000006469005122264257677_);}\n\t.st32{fill:url(#SVGID_00000085955483672669284240000006678088342012118433_);}\n\t.st33{fill:url(#SVGID_00000101791647232686285590000005490528816059052423_);}\n\t.st34{fill:url(#SVGID_00000117659704244507492160000013041691790417000844_);}\n\t.st35{fill:url(#SVGID_00000119116309850545256630000004532156640118558612_);}\n\t.st36{fill:url(#SVGID_00000055695069472110898040000003350941798443789199_);}\n\t.st37{fill:url(#SVGID_00000029045297675085509120000006237378164169817744_);}\n\t.st38{fill:url(#SVGID_00000052101738996556505140000007778824743233611153_);}\n\t.st39{fill:url(#SVGID_00000099634193642767681350000014649501021895368861_);}\n\t.st40{fill:url(#SVGID_00000049944326903854452230000015796321145420181682_);}\n\t.st41{fill:url(#SVGID_00000049911910972518494350000017208211642150947495_);}\n\t.st42{fill:url(#SVGID_00000079451252251489728520000016412181827234342314_);}\n\t.st43{fill:url(#SVGID_00000025402809984261482010000015174910559331210139_);}\n\t.st44{fill:url(#SVGID_00000048469082518514078360000005984509227848427408_);}\n\t.st45{fill:url(#SVGID_00000131336182792919017450000000527548840254679968_);}\n\t.st46{fill:url(#SVGID_00000086679071478995966710000018097758948533613485_);}\n\t.st47{fill:url(#SVGID_00000090286201600029525150000006845000790927974535_);}\n\t.st48{fill:url(#SVGID_00000124142244818942474950000010344374952795506057_);}\n\t.st49{fill:url(#SVGID_00000042709615905879717890000000952585151389089935_);}\n\t.st50{fill:url(#SVGID_00000018202280162342069320000008646516002011446201_);}\n\t.st51{fill:url(#SVGID_00000057834451399395958920000013306702382072002451_);}\n\t.st52{fill:url(#SVGID_00000087381925592343974640000009065863821081198720_);}\n\t.st53{fill:url(#SVGID_00000019664460911373967800000000777883488163855767_);}\n\t.st54{fill:url(#SVGID_00000106858802025277579650000007630050154791355796_);}\n\t.st55{fill:url(#SVGID_00000081628577442252541570000005455190769032237462_);}\n\t.st56{fill:url(#SVGID_00000142897646166169592850000008863090638398597529_);}\n\t.st57{fill:#FFFFFF;}\n\t.st58{fill:url(#SVGID_00000149342097901670420560000009842502238331463056_);}\n\t.st59{fill:url(#SVGID_00000097497208647360584900000015134330010698707384_);}\n\t.st60{fill:url(#SVGID_00000159452945705556157010000000207376691688000129_);}\n\t.st61{fill:url(#SVGID_00000117673802648754724190000006312102633245050016_);}\n\t.st62{fill:url(#SVGID_00000060028708725388435630000010348147702104251538_);}\n\t.st63{fill:url(#SVGID_00000155861952061879570640000000907183186824064701_);}\n\t.st64{fill:url(#SVGID_00000057106520191261107350000013461669518655623862_);}\n\t.st65{fill:url(#SVGID_00000173840438386545755480000003040780794855647674_);}\n\t.st66{fill:url(#SVGID_00000139994193011294858020000000492127220465791630_);}\n\t.st67{fill:url(#SVGID_00000011724310400917500570000012867829987315842178_);}\n\t.st68{fill:url(#SVGID_00000152230472956628400240000018106863927299509390_);}\n\t.st69{fill:url(#SVGID_00000018946222244016664640000001864376291885961364_);}\n\t.st70{fill:url(#SVGID_00000050620916728974139560000017682121625442988954_);}\n\t.st71{fill:url(#SVGID_00000150803650754245845800000016069585782773044391_);}\n\t.st72{fill:url(#SVGID_00000124123889203820904180000016647579666194613385_);}\n\t.st73{fill:url(#SVGID_00000020395037568350473070000004745866538229165961_);}\n\t.st74{fill:url(#SVGID_00000039837007197419557120000000723416838555949484_);}\n\t.st75{fill:url(#SVGID_00000138536661326732634000000010336316122143406466_);}\n\t.st76{fill:url(#SVGID_00000131341772305072884320000003165973119702274733_);}\n\t.st77{fill:url(#SVGID_00000106853298738603230650000008391035109839860156_);}\n\t.st78{fill:url(#SVGID_00000062155770755226582170000013151422691032885640_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.6858,
    y1: 44.8767,
    x2: 38.3454,
    y2: 12.5362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.98,36.49c-4.97,0-9.94,0-14.91,0c-0.94,0-1.88,0-2.82,0c0-3.54,0-7.09,0-10.63c0-2.41-3.75-2.42-3.75,0 c0,4.17,0,8.34,0,12.51c0,1.01,0.86,1.88,1.88,1.88c5.36,0,10.72,0,16.08,0c1.17,0,2.35,0,3.52,0 C31.4,40.24,31.4,36.49,28.98,36.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183936824731907825230000002433413853839112358_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.9992,
    y1: 40.2887,
    x2: 33.6588,
    y2: 7.9483
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183936824731907825230000002433413853839112358_)"
    },
    d: "M19.8,8.51c4.94,0,9.87,0,14.81,0 c0.07,0,0.15,0,0.22,0c0,3.93,0,7.86,0,11.79c0,2.41,3.75,2.42,3.75,0c0-4.56,0-9.11,0-13.67c0-1.01-0.86-1.88-1.88-1.88 c-4.94,0-9.87,0-14.81,0c-0.7,0-1.4,0-2.09,0C17.39,4.76,17.39,8.51,19.8,8.51z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180360480371409631360000013725542621672180390_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.151,
    y1: 52.1847,
    x2: 45.8106,
    y2: 19.8443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180360480371409631360000013725542621672180390_)"
    },
    d: "M41.9,32.38 c0.26-0.34,0.43-0.71,0.43-1.17c0-0.46-0.2-1.01-0.55-1.33c-1.94-2.13-3.87-4.26-5.81-6.38c-0.68-0.75-1.96-0.69-2.65,0 c-0.75,0.75-0.68,1.9,0,2.65c0.97,1.06,1.93,2.12,2.9,3.18c-2.27,0-4.54,0-6.81,0c-0.53,0-1.06,0-1.59,0 c-1.01,0-1.88,0.86-1.88,1.88c0,1.02,0.86,1.87,1.88,1.87c2.88,0,5.77,0,8.65,0c-0.85,1.02-1.69,2.04-2.54,3.06 c-0.25,0.3-0.49,0.59-0.74,0.89c-0.33,0.39-0.55,0.8-0.55,1.33c0,0.46,0.2,1.01,0.55,1.33c0.69,0.63,1.98,0.81,2.65,0 c1.73-2.09,3.47-4.17,5.2-6.26c0.25-0.3,0.49-0.59,0.74-0.89c0.04-0.05,0.07-0.1,0.11-0.15C41.89,32.39,41.9,32.39,41.9,32.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043415756946271578390000001502295963954360205_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.0139,
    y1: 31.4654,
    x2: 24.6456,
    y2: -0.8751
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043415756946271578390000001502295963954360205_)"
    },
    d: "M11.68,21.47c0.75-0.75,0.68-1.9,0-2.65 c-0.97-1.06-1.93-2.12-2.9-3.18c2.27,0,4.54,0,6.81,0c0.53,0,1.06,0,1.59,0c1.01,0,1.88-0.86,1.88-1.88c0-1.02-0.86-1.88-1.88-1.88 c-2.88,0-5.77,0-8.65,0c0.85-1.02,1.69-2.04,2.54-3.06c0.25-0.3,0.49-0.59,0.74-0.89c0.33-0.39,0.55-0.8,0.55-1.33 c0-0.46-0.2-1.01-0.55-1.33c-0.69-0.63-1.98-0.81-2.65,0c-1.73,2.09-3.47,4.17-5.2,6.26c-0.25,0.3-0.49,0.59-0.74,0.89 c-0.04,0.05-0.07,0.1-0.11,0.15c0,0-0.01,0.01-0.01,0.01c-0.26,0.34-0.43,0.71-0.43,1.17c0,0.46,0.2,1.01,0.55,1.33 c1.94,2.13,3.87,4.26,5.81,6.38C9.71,22.21,10.99,22.16,11.68,21.47z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150067968166535828880000007282735080155671178_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.0531,
    y1: 46.2152,
    x2: 39.7127,
    y2: 13.8748
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150067968166535828880000007282735080155671178_)"
    },
    d: "M30.67,23.33c-0.98,0-1.97,0-2.95,0 c-0.14,0-0.28,0-0.42,0c-0.38,0-0.79,0.17-1.06,0.44c-0.26,0.26-0.46,0.69-0.44,1.06c0.04,0.81,0.66,1.5,1.5,1.5 c0.98,0,1.97,0,2.95,0c0.14,0,0.28,0,0.42,0c0.38,0,0.79-0.17,1.06-0.44c0.26-0.26,0.46-0.69,0.44-1.06 C32.13,24.02,31.51,23.33,30.67,23.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162319756457161418900000003570493065076058559_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.985,
    y1: 41.2538,
    x2: 34.6446,
    y2: 8.9134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162319756457161418900000003570493065076058559_)"
    },
    d: "M22.57,23.33c-2.05,0-4.11,0-6.16,0 c-0.29,0-0.58,0-0.87,0c-0.78,0-1.54,0.69-1.5,1.5c0.04,0.81,0.66,1.5,1.5,1.5c2.05,0,4.11,0,6.16,0c0.29,0,0.58,0,0.87,0 c0.78,0,1.54-0.69,1.5-1.5C24.04,24.02,23.42,23.33,22.57,23.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045584126785419523330000000797179293370557876_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.2775,
    y1: 43.498,
    x2: 36.937,
    y2: 11.1576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045584126785419523330000000797179293370557876_)"
    },
    d: "M30.67,17.78c-0.98,0-1.97,0-2.95,0 c-0.14,0-0.28,0-0.42,0c-0.38,0-0.79,0.17-1.06,0.44c-0.26,0.26-0.46,0.69-0.44,1.06c0.04,0.81,0.66,1.5,1.5,1.5 c0.98,0,1.97,0,2.95,0c0.14,0,0.28,0,0.42,0c0.38,0,0.79-0.17,1.06-0.44c0.26-0.26,0.46-0.69,0.44-1.06 C32.13,18.47,31.51,17.78,30.67,17.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077316014514815594530000005136607100746343095_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.2094,
    y1: 38.5366,
    x2: 31.8689,
    y2: 6.1962
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077316014514815594530000005136607100746343095_)"
    },
    d: "M22.57,17.78c-2.05,0-4.11,0-6.16,0 c-0.29,0-0.58,0-0.87,0c-0.78,0-1.54,0.69-1.5,1.5c0.04,0.81,0.66,1.5,1.5,1.5c2.05,0,4.11,0,6.16,0c0.29,0,0.58,0,0.87,0 c0.78,0,1.54-0.69,1.5-1.5C24.04,18.47,23.42,17.78,22.57,17.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079462778651996956670000015212899250219438228_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.1758,
    y1: 44.3774,
    x2: 37.8353,
    y2: 12.037
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079462778651996956670000015212899250219438228_)"
    },
    d: "M22.57,29.72c-2.05,0-4.11,0-6.16,0 c-0.29,0-0.58,0-0.87,0c-0.78,0-1.54,0.69-1.5,1.5c0.04,0.81,0.66,1.5,1.5,1.5c2.05,0,4.11,0,6.16,0c0.29,0,0.58,0,0.87,0 c0.78,0,1.54-0.69,1.5-1.5C24.04,30.4,23.42,29.72,22.57,29.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059306554902827688520000002198777682777326255_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.1014,
    y1: 39.4098,
    x2: 32.7609,
    y2: 7.0694
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE4035"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6935A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059306554902827688520000002198777682777326255_)"
    },
    d: "M30.81,12.23c-2.67,0-5.34,0-8.01,0 c-0.38,0-0.76,0-1.13,0c-0.78,0-1.54,0.69-1.5,1.5c0.04,0.81,0.66,1.5,1.5,1.5c2.67,0,5.34,0,8.01,0c0.38,0,0.76,0,1.13,0 c0.78,0,1.54-0.69,1.5-1.5C32.28,12.92,31.66,12.23,30.81,12.23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChuyenDoiUidSdt);
export default __webpack_public_path__ + "static/media/icon_Chuyen_doi_UID_SDT.e16d7ba39dda583089c0bd67523b10b8.svg";
export { ForwardRef as ReactComponent };